export const PRELOAD = 'PRELOAD'
export const SHOWCASE = 'SHOWCASE'
export const PRODUCT_INFO = 'PRODUCT_INFO'
export const PRODUCT_DETAILS = 'PRODUCT_DETAILS'



// WEBPACK FOOTER //
// ./src/templates/insta/scenes.js